export default function SectionTag({ number, label, light = false }) {
  return (
    <div
      data-testid={`section-tag-${number}`}
      className={`flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.28em] ${
        light ? 'text-white/50' : 'text-white/50'
      }`}
    >
      <span className="font-display text-[#47a0d9]">{number}</span>
      <span className="h-px w-10 bg-white/25" />
      <span>{label}</span>
    </div>
  );
}
